import PageHeader from 'components/ui-kit/page-header';
import { InfoBox, InfoBoxItem, InfoBoxGroup } from 'components/ui-kit/info-box';
import InfoPlaceholder from 'components/ui-kit/info-placeholder';
import AppearanceSwitcher from 'components/appearance-switcher';
import Money from 'components/ui-kit/money';
import getPhoneNumber from 'helpers/getPhoneNumber.helper';
import { useApp } from 'hooks';

export default function Profile() {
  const { user } = useApp();

  // Billing address move to first position
  const properties = user?.addresses?.map((x, index) => ({
    ...x,
    title: x.location === user.billingAddress?.location ? 'Billing property' : `Property ${index + 1}`,
  }));
  const sortedProperties = properties?.sort((a, b) => ((a.title > b.title ? 1 : -1)));

  return (
    <>
      <PageHeader title="Profile" />
      <InfoBoxGroup>
        <InfoBox title="Personal Info">
          <InfoBoxItem title="Name" value={`${user?.firstName} ${user?.lastName}`} />
          <InfoBoxItem title="Email" value={user?.email} />
          <InfoBoxItem
            title="Primary Phone"
            value={getPhoneNumber(user?.phoneNumber) || '-'}
          />
          {user?.secondaryPhoneNumbers?.length > 0 && (
            <InfoBoxItem
              title="Additional Phone(s)"
              value={user?.secondaryPhoneNumbers.map((n) => `${getPhoneNumber(n)}\n`)}
            />
          )}
        </InfoBox>
        {user?.creditBalance > 0 && (
          <InfoBox title="Account Credit">
            <InfoBoxItem
              title="Balance"
              value={<Money amount={user.creditBalance} />}
              description="Applied automatically to your next invoice."
            />
          </InfoBox>
        )}
        <InfoBox title="Properties">
          {(sortedProperties?.length)
            ? sortedProperties?.map((item, index) => (
              <InfoBoxItem
                key={`address-${String(index)}`}
                title={item?.title}
                value={item?.location}
                description={item?.unitNumber ? `Unit #: ${item.unitNumber}` : ''}
              />
            ))
            : <InfoPlaceholder text="No properties set" />}
        </InfoBox>
        <InfoBox title="Appearance">
          <AppearanceSwitcher />
        </InfoBox>
      </InfoBoxGroup>
    </>
  );
}
